// Configuration de l'API
const BACKEND_URL = '/api';

// Fonction utilitaire pour effectuer des requêtes avec authentification
async function fetchWithAuth(url, options = {}) {
    const token = localStorage.getItem('authToken');
    const headers = {
        'Content-Type': 'application/json',
        ...options.headers
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(url, {
        ...options,
        headers
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || 'Une erreur est survenue');
    }

    return response;
}

// Fonction pour récupérer la configuration IA depuis le backend
async function getAIConfig() {
    try {
        const response = await fetchWithAuth(`${BACKEND_URL}/ai/config`);
        return await response.json();
    } catch (error) {
        console.error('Erreur lors de la récupération de la configuration IA:', error);
        // Retourner une configuration par défaut en cas d'erreur
        return {
            api_url: 'https://www.4styl.com/api/chat',
            model: 'llama3',
            is_active: true
        };
    }
}

// Fonction pour générer du contenu avec l'IA
async function generateWithAI() {
    const postTitleInput = document.getElementById('postTitle');
    const postContentInput = document.getElementById('postContent');
    const savePostBtn = document.getElementById('savePost');
    const aiSuggestBtn = document.getElementById('aiSuggestBtn');
    
    if (!postTitleInput || !postContentInput || !savePostBtn || !aiSuggestBtn) {
        console.error('Éléments du formulaire non trouvés');
        return;
    }

    const title = postTitleInput.value.trim();
    
    // Vérification du titre
    if (!title) {
        alert('Veuillez d\'abord entrer un titre pour générer une suggestion');
        return;
    }
    
    try {
        // Désactivation du bouton et affichage du chargement
        savePostBtn.disabled = true;
        aiSuggestBtn.innerHTML = '<i class="fas fa-spinner fa-spin mr-1"></i>Génération...';
        
        // Récupérer la configuration IA
        const aiConfig = await getAIConfig();
        
        // Appel à l'API IA via le backend
        const response = await fetchWithAuth(`${BACKEND_URL}/ai/generate`, {
            method: 'POST',
            body: JSON.stringify({
                model: aiConfig.model,
                prompt: `Génère un article de blog sur le sujet : ${title}`,
                stream: false
            })
        });
        
        // Traitement de la réponse
        const data = await response.json();
        console.log('[IA] Réponse reçue:', data);
        
        // Mise à jour du contenu avec la réponse
        postContentInput.value = data.response?.trim() || data.text?.trim() || data;
        
    } catch (error) {
        console.error('[IA] Erreur lors de la génération:', error);
        alert(`Erreur lors de la génération avec IA: ${error.message || 'Veuillez vérifier la configuration et réessayer'}`);
    } finally {
        // Réactivation du bouton et remise à jour du texte
        if (savePostBtn) savePostBtn.disabled = false;
        if (aiSuggestBtn) {
            aiSuggestBtn.innerHTML = '<i class="fas fa-magic mr-1"></i>Suggérer avec IA';
        }
    }
}

// Exposer la fonction generateWithAI au scope global
window.generateWithAI = generateWithAI;
